// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"93a4dd8a","239":"5baef066","344":"87970cc3","351":"f979c07f","455":"de792acb","625":"c95bf4d0","701":"9a6029c0","766":"f69db03d","813":"e6e90ca5","977":"d9f3b7a0"}[chunkId] + ".chunk.js";
};